module.exports = __webpack_public_path__ + "img/40_69_000_870.7d801d15.jpg";